<script>
import {useMenuStore} from "@js/store/MenuStore.js";
import {Link} from "@inertiajs/vue3";

export default {
    name: "HomeCatalogNavigation",
    components: {Link},
    setup() {
        const menuStore = useMenuStore()
        const menuItems = menuStore.menuItems
            .find((item) => item.type === 'products_menu')
            ?.submenu
            .flatMap(item => item.submenu || [])

        return {menuStore, menuItems}
    },
}
</script>

<template>
    <div class="pt-10">
        <div class="container">
<!--            <h2 class="text-2xl md:text-3xl font-semibold text-start md:text-center mb-10">-->
<!--                Каталог ЖБИ продукции-->
<!--            </h2>-->
            <div class="grid grid-cols-1 md:grid-cols-4 gap-5">
                <div v-for="submenu in menuItems" :key="submenu.title" class="inline-flex gap-5">
                    <Link :href="route(submenu.route_name, submenu.route_params ?? {})" class="flex-none">
                        <img :src="submenu.icon_path"
                             class="block w-16 h-16" alt="catalog_log"/>
                    </Link>
                    <div>
                        <div class="mb-1">
                            <Link :href="route(submenu.route_name, submenu.route_params ?? {})"
                                  class="text-sm md:text-base font-semibold hover:text-indigo-600 transition">
                                {{ submenu.title }}
                            </Link>
                        </div>
                        <Link :href="route(submenu.route_name, submenu.route_params ?? {})"
                              class="inline-block md:block text-[13px] pe-[7px] py-[3px] me-2 font-medium hover:text-indigo-600 transition"
                              v-for="product in submenu.submenu">
                            {{ product.title }}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
